import { useState } from "react";
import { useDispatch } from "react-redux";

import { Popup } from "../../../components/pop-up";
import { StaticTooltip } from "../../../components/static_tooltip";

import * as actions from "../../../actions";
import { IconButton } from "../../../components/buttons";

export function ResendOnboardingLink({ data }) {
  const dispatch = useDispatch();

  const [resendModal, setResendModal] = useState();

  return (
    <>
      <StaticTooltip placement="bottom" content="Resend Account Setup Link">
        <IconButton
          size="sm"
          onClick={() => setResendModal("pop-up")}
          class="rounded-xl bg-indigo-100 p-2 text-indigo-600 hover:bg-indigo-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
            />
          </svg>
        </IconButton>
      </StaticTooltip>
      <Popup
        modalState={[resendModal, setResendModal]}
        onConfirm={() => {
          dispatch(actions.RESENDONBOARDINGLINK_REQ(data));
          setResendModal();
        }}
        content={
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              This will send a new account setup link to{" "}
              <b>{data?.email}</b> and invalidate any previous link. The
              coworker will need to complete 2FA setup and choose a new
              password before they can sign in again.
            </h3>
          </>
        }
      />
    </>
  );
}
